module.exports = __webpack_public_path__ + "static/media/snowman.4e99fe23.svg";